import { render, staticRenderFns } from "./AppDownloadColorioNenga.vue?vue&type=template&id=37f17d88&scoped=true&"
import script from "./AppDownloadColorioNenga.vue?vue&type=script&lang=js&"
export * from "./AppDownloadColorioNenga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f17d88",
  null
  
)

export default component.exports